import LightBoard from "./LightBoard";
import DarkBoard from "./DarkBoard";

const FIELD_SCALE = 1.15;
const vh = (n) => +(n * FIELD_SCALE).toFixed(3) + "vh";

const cfg = {
  pad: "2vh 2.5vw",
  iconSize: vh(3.2),
  iconBox: vh(5.2),
  titleSize: vh(3.6),
  airportSize: vh(1.7),
  clockSize: vh(1.9),
  headSize: vh(1.1),
  rowSize: vh(1.7),
  badgeSize: vh(2.4),
  badgeFont: vh(0.98),
  rowMin: vh(4.4),
  compact: true,
  cols: "12% 15% 39% 14% 20%",
  statusColWidth: "16%",
  dualPad: "1.8vh 2.2vw",
  dualDir: "column",
  dualCols: "12% 15% 39% 14% 20%",
  dualTitleSize: vh(2.4),
  dualAirportSize: vh(1.6),
  dualClockSize: vh(1.9),
  dualHeadSize: vh(1.25),
  dualRowSize: vh(1.85),
  dualBadgeSize: vh(2.5),
  dualBadgeFont: vh(1.05),
  dualIconBox: vh(4.2),
  dualIconSize: vh(2.8),
  dualRowMin: vh(2.6),
  sectionIconBox: vh(2.5),
  sectionIconSize: vh(1.7),
  sectionTitleSize: vh(1.55),
};

const Portrait = (props) => {
  const Board = props.theme === "dark" ? DarkBoard : LightBoard;
  return <Board {...props} cfg={cfg} />;
};

export default Portrait;
